<div id="reno-bg">

</div>
<div class="reno-cup-banner">
  <img src="assets/img/oppo-egypt/banner.jpg" class="img-responsive hidden-xs" >
  <img src="assets/img/oppo-egypt/banner-mob-view.jpg" class="img-responsive hidden-lg hidden-md hidden-sm" >

</div>
<perfect-scrollbar class="scroll-x-container">

  <div class="menu-container">
    <div class="container" >
      <div class="menu">

    <div class="item" routerLink="./tournaments" routerLinkActive="active">
          <p>Tournaments</p>
        </div>
        <div class="item" routerLink="./qualified-player" routerLinkActive="active">
          <p>Winners</p>
        </div>
        <div class="item" routerLink="./rules-terms" routerLinkActive="active">
          <p> Rules & Terms</p>
        </div>
      <div class="item" routerLink="./prizes" routerLinkActive="active">
          <p>Prizes</p>
        </div>
      </div>
    </div>


  </div>
</perfect-scrollbar>


<router-outlet></router-outlet>

<app-oppo-egypt-footer></app-oppo-egypt-footer>
